import Cookie from 'js-cookie'

export default {
  namespaced: true,
  state: {
    profile: null,
    isSignIn: Cookie.get('access_token') !== undefined,
    regEmail: ''
  },

  getters: {
    profile: state => state.profile,
    isSignIn: state => state.isSignIn,
    regEmail: state => state.regEmail
  },

  mutations: {
    SET_PROFILE: (state, payload = null) => {
      state.profile = payload
      state.isSignIn = !!payload
      state.regEmail = ''
    },

    SET_REG_EMAIL: (state, payload = null) => {
      state.regEmail = payload
    }
  },

  actions: {
    REFRESH_TOKEN: async function ({ dispatch }, payload) {
      const { data } = await this.$api.auth.refreshToken(payload)
      this.resetJWT(data)
      await dispatch('GET_PROFILE')
    },

    SIGNIN: async function ({ dispatch }, payload) {
      this.resetJWT(payload)
      return dispatch('GET_PROFILE')
    },

    REGISTER: async function ({ commit }, payload) {
      commit('SET_REG_EMAIL', payload)
    },

    SIGNOUT: async function ({ commit }) {
      commit('SET_PROFILE')
      this.removeJWT()
    },

    CLEAR_PROFILE: async function ({ commit }) {
      commit('SET_PROFILE')
      this.removeJWT()
    },

    GET_PROFILE: async function ({ commit }) {
      return new Promise((resolve, reject) => {
        this.$api.auth.profile().then(({ data }) => {
          commit('SET_PROFILE', data)
          resolve(data)
        }).catch((e) => {
          reject(e)
        })
      })
    }
  }
}
